import BaseService from "../BaseService";
import _ from "lodash";

class CustomerService extends BaseService {

    me = async () => {
        var data = await this._api.post("store/user/me");
        return data;
    };

    requestOTPLogin = async (phone, customer_info) => {
        var data = await this._api.post("store/user/request_otp_login", { phone, customer_info });
        return data;
    };

    otpLogin = async ( id, otp ) => {
        var data = await this._api.post("store/user/otp_login", { id, otp });
        return data;
    };

    accountLogin = async (account, password) => {
        var data = await this._api.post("store/user/account_login", { account, password });
        return data;
    };






  

    login = async () => {
        var data = await this._api.post("store/cart/create");
        return data;
    };

    get = async (id) => {
        var data = await this._api.get(`/store/cart/get`, { params: { id } });
        return data;
    };

    updateLineItem = async ({ id, line }) => {
        var data = await this._api.post(`/store/cart/update_line_item`, { id, line });
        return data;
    }


    addLineItem = async ({ id, line }) => {
        var data = await this._api.post(`/store/cart/add_line_item`, { id, line });
        return data;
    }

    updateShippingAddress = async ({ id, shipping_address }) => {
        var data = await this._api.post(`/store/cart/update_shipping_address`, { id, shipping_address });
        return data;
    }


    createInvoiceFile = async ({ id }) => {
        var data = await this._api.post(`/store/cart/create_invoice_file`, { id });
        return data;
    }


}
export default CustomerService;
